"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESCROW_AUTH = exports.STAKING_VARS = exports.STAKING_ESCROW = exports.STAKING_ACCOUNT = exports.REWARD_AUTH = exports.REWARD_ACCOUNT = exports.REGISTERED_STAKE = void 0;
exports.REGISTERED_STAKE = Buffer.from('registered-stake');
exports.REWARD_ACCOUNT = Buffer.from('reward-account');
exports.REWARD_AUTH = Buffer.from('reward-vault-authority');
exports.STAKING_ACCOUNT = Buffer.from('staking-account');
exports.STAKING_ESCROW = Buffer.from('staking-escrow');
exports.STAKING_VARS = Buffer.from('staking-vars');
exports.ESCROW_AUTH = Buffer.from('escrow-auth');
//# sourceMappingURL=seeds.js.map